import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Books from "@/pages/Books";
import AboutDhamma from "@/pages/AboutDhamma";
import AboutBugg from "@/pages/AboutBugg";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Arc from "@/pages/Arc";
import ArcAgreement from "@/pages/ArcAgreement";
import ArcShipping from "@/pages/ArcShipping";
import ArcOfferDigital from "@/pages/ArcOfferDigital";
import { AdminAuthProvider, useAdminAuth } from "@/admin/AdminAuth";
import AdminLogin from "@/admin/AdminLogin";
import AdminDashboard from "@/admin/AdminDashboard";

function RequireAdmin({ children }) {
  const { admin, checking } = useAdminAuth();
  if (checking)
    return <div className="flex min-h-screen items-center justify-center bg-dh-bg font-body text-sm text-dh-muted">Loading…</div>;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}

function PublicSite() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/books" element={<Books />} />
        <Route path="/about-dhamma" element={<AboutDhamma />} />
        <Route path="/about-bugg" element={<AboutBugg />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/arc" element={<Arc />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AdminAuthProvider>
        <Routes>
          {/* Private admin — intentionally not linked from public navigation */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <AdminDashboard />
              </RequireAdmin>
            }
          />
          {/* Private token-gated ARC agreement — standalone, not linked publicly */}
          <Route path="/arc/agreement/:token" element={<ArcAgreement />} />
          <Route path="/arc/shipping/:token" element={<ArcShipping />} />
          <Route path="/arc/offer-digital/:token" element={<ArcOfferDigital />} />
          {/* Public site */}
          <Route path="/*" element={<PublicSite />} />
        </Routes>
      </AdminAuthProvider>
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#0a120c",
            border: "1px solid rgba(197,160,89,0.3)",
            color: "#fdfbf7",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
